import React from "react"

// =============================================================================
// Props
// =============================================================================

export type NavigationFooterProps = {
  /** Content pinned to the bottom of the sidebar (nav items, account button, etc.) */
  children?: React.ReactNode
}

// =============================================================================
// Styles
// =============================================================================

const footerStyles = "mt-auto flex flex-col gap-2"

// =============================================================================
// Component
// =============================================================================

/**
 * Pins its children to the bottom of the sidebar, visually separating them
 * from the scrollable area above.
 *
 * The app layer decides what goes inside — pass any children (nav items,
 * account buttons, etc.).
 */
export function NavigationFooter({ children }: NavigationFooterProps) {
  return (
    <div data-slot="navigation-footer" className={footerStyles}>
      {children}
    </div>
  )
}

NavigationFooter.displayName = "Navigation.Footer"
